const SELECTED_PLAN_STORAGE_KEY = 'practium:selectedPlanId';
const CHECKOUT_MODE_STORAGE_KEY = 'practium:checkoutMode';

export type CheckoutMode = 'sign' | 'upgrade';

export const getStoredSelectedPlanId = (): string | null =>
	sessionStorage.getItem(SELECTED_PLAN_STORAGE_KEY);

export const setStoredSelectedPlanId = (planId: string): void => {
	sessionStorage.setItem(SELECTED_PLAN_STORAGE_KEY, planId);
};

export const clearStoredSelectedPlanId = (): void => {
	sessionStorage.removeItem(SELECTED_PLAN_STORAGE_KEY);
};

export const getStoredCheckoutMode = (): CheckoutMode => {
	const value = sessionStorage.getItem(CHECKOUT_MODE_STORAGE_KEY);
	return value === 'upgrade' ? 'upgrade' : 'sign';
};

export const setStoredCheckoutMode = (mode: CheckoutMode): void => {
	sessionStorage.setItem(CHECKOUT_MODE_STORAGE_KEY, mode);
};

export const clearStoredCheckoutMode = (): void => {
	sessionStorage.removeItem(CHECKOUT_MODE_STORAGE_KEY);
};
